/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ APP_NAME: NonNullable<unknown> }} Link_Account_Page_TitleInputs */

const en_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link Account | ${i?.APP_NAME}`)
};

const id_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hubungkan Akun | ${i?.APP_NAME}`)
};

const ms_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pautkan Akaun | ${i?.APP_NAME}`)
};

const ca_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enllaç de compte | ${i?.APP_NAME}`)
};

const cs_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odkaz na účet | ${i?.APP_NAME}`)
};

const da_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link-konto | ${i?.APP_NAME}`)
};

const de_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Konto verknüpfen | ${i?.APP_NAME}`)
};

const et_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Konto sidumine | ${i?.APP_NAME}`)
};

const es_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vincular la cuenta | ${i?.APP_NAME}`)
};

const fr_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lier le compte | ${i?.APP_NAME}`)
};

const hr_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Povezivanje računat | ${i?.APP_NAME}`)
};

const it_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Collega account | ${i?.APP_NAME}`)
};

const lv_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piesaistīt kontu | ${i?.APP_NAME}`)
};

const lt_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Susieti paskyrą | ${i?.APP_NAME}`)
};

const hu_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fiók társítása | ${i?.APP_NAME}`)
};

const nl_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link account | ${i?.APP_NAME}`)
};

const nb_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Koble til konto | ${i?.APP_NAME}`)
};

const pl_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Połącz konto | ${i?.APP_NAME}`)
};

const pt_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vincular conta | ${i?.APP_NAME}`)
};

const ro_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conectează contul | ${i?.APP_NAME}`)
};

const sk_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prepojiť účet | ${i?.APP_NAME}`)
};

const sl_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Povezava do računa | ${i?.APP_NAME}`)
};

const fi_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linkitä tili | ${i?.APP_NAME}`)
};

const sv_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Länka konto | ${i?.APP_NAME}`)
};

const vi_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Liên kết tài khoản | ${i?.APP_NAME}`)
};

const tr_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bağlantı Hesabı | ${i?.APP_NAME}`)
};

const el_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Σύνδεση λογαριασμού | ${i?.APP_NAME}`)
};

const bg_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Свързване на акаунт | ${i?.APP_NAME}`)
};

const ru_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Привязать аккаунт | ${i?.APP_NAME}`)
};

const sr_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Повезивање налога | ${i?.APP_NAME}`)
};

const uk_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обліковий запис | ${i?.APP_NAME}`)
};

const ka_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ანგარიშის დაკავშირება | ${i?.APP_NAME}`)
};

const hi_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`लिंक अकाउंट | ${i?.APP_NAME}`)
};

const th_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เชื่อมโยงบัญชี | ${i?.APP_NAME}`)
};

const ko_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`계정 연결 | ${i?.APP_NAME}`)
};

const zh_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`链接账户 | ${i?.APP_NAME}`)
};

const zh_tw_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`連結帳戶 | ${i?.APP_NAME}`)
};

const ja_link_account_page_title = /** @type {(inputs: Link_Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link Account｜ ${i?.APP_NAME}`)
};

/**
* | output |
* | --- |
* | "Link Account \| {APP_NAME}" |
*
* @param {Link_Account_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const link_account_page_title = /** @type {((inputs: Link_Account_Page_TitleInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Account_Page_TitleInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_link_account_page_title(inputs)
	if (locale === "ms") return ms_link_account_page_title(inputs)
	if (locale === "ca") return ca_link_account_page_title(inputs)
	if (locale === "cs") return cs_link_account_page_title(inputs)
	if (locale === "da") return da_link_account_page_title(inputs)
	if (locale === "de") return de_link_account_page_title(inputs)
	if (locale === "et") return et_link_account_page_title(inputs)
	if (locale === "es") return es_link_account_page_title(inputs)
	if (locale === "fr") return fr_link_account_page_title(inputs)
	if (locale === "hr") return hr_link_account_page_title(inputs)
	if (locale === "it") return it_link_account_page_title(inputs)
	if (locale === "lv") return lv_link_account_page_title(inputs)
	if (locale === "lt") return lt_link_account_page_title(inputs)
	if (locale === "hu") return hu_link_account_page_title(inputs)
	if (locale === "nl") return nl_link_account_page_title(inputs)
	if (locale === "nb") return nb_link_account_page_title(inputs)
	if (locale === "pl") return pl_link_account_page_title(inputs)
	if (locale === "pt") return pt_link_account_page_title(inputs)
	if (locale === "ro") return ro_link_account_page_title(inputs)
	if (locale === "sk") return sk_link_account_page_title(inputs)
	if (locale === "sl") return sl_link_account_page_title(inputs)
	if (locale === "fi") return fi_link_account_page_title(inputs)
	if (locale === "sv") return sv_link_account_page_title(inputs)
	if (locale === "vi") return vi_link_account_page_title(inputs)
	if (locale === "tr") return tr_link_account_page_title(inputs)
	if (locale === "el") return el_link_account_page_title(inputs)
	if (locale === "bg") return bg_link_account_page_title(inputs)
	if (locale === "ru") return ru_link_account_page_title(inputs)
	if (locale === "sr") return sr_link_account_page_title(inputs)
	if (locale === "uk") return uk_link_account_page_title(inputs)
	if (locale === "ka") return ka_link_account_page_title(inputs)
	if (locale === "hi") return hi_link_account_page_title(inputs)
	if (locale === "th") return th_link_account_page_title(inputs)
	if (locale === "ko") return ko_link_account_page_title(inputs)
	if (locale === "zh") return zh_link_account_page_title(inputs)
	if (locale === "zh-tw") return zh_tw_link_account_page_title(inputs)
	if (locale === "ja") return ja_link_account_page_title(inputs)
	return en_link_account_page_title(inputs)
});